// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';

//HOOKS
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";


// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";

interface ServicesProps {
    agencyId: number;
}

const Services: React.FC<ServicesProps> = ({agencyId}) => {

    const { t } = useTranslation();

    const { agency } = useGetAgencyDetails(agencyId);

    const listItems1 = [
        t('servicesPage.list1.service1'),
        t('servicesPage.list1.service2'),
        t('servicesPage.list1.service3'),
        t('servicesPage.list1.service4'),
        t('servicesPage.list1.service5'),
        t('servicesPage.list1.service6')
    ];

    const listItems2 = [
        t('servicesPage.list2.service1'),
        t('servicesPage.list2.service2'),
        t('servicesPage.list2.service3')
    ];

    return (
        <>
            <Helmet>
                <title>{t('servicesPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
            </Helmet>

            <SubHeaderDefault title={t('servicesPage.pageTitle')} isSeo={true} />

            <main id="services-page" className="space-ptb">
                <div className="container-fluid w-90">
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para1') as string}}></p>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para2') as string}}></p>
                    <ul>
                        {listItems1.map((item, index) => (
                            <li key={index} dangerouslySetInnerHTML={{ __html: item as string }}></li>
                        ))}
                    </ul>
                    <p dangerouslySetInnerHTML={{ __html: t('servicesPage.para3') as string}}></p>  
                    <ul>
                        {listItems2.map((item, index) => (
                            <li key={index} dangerouslySetInnerHTML={{ __html: item as string }}></li>
                        ))}
                    </ul>
                </div>
            </main>
        </>
    );
};

export default Services;